import { observer } from 'mobx-react-lite'
import { ContainerHeader, variantActionsProps } from 'shared/ui'
import { Breadcrumbs } from 'shared/ui/Breadcrumbs'
import { SurveyStatus } from 'entities/Surveys'
import { SurveysPath } from 'pages/surveys'
import { useViewPageContext } from 'pages/surveys/pages/view/context/viewContext'
import { useSurveysPageContext } from 'pages/surveys/context/surveysPageContext'
import { SurveyActiveToggle } from 'pages/surveys/ui/SurveyActiveToggle'
import styles from './styles.module.scss'

export const ViewHeader = observer(() => {
  const { actions, dataStatus, onChangeStatus, survey } = useViewPageContext()
  const { pageLayoutStore } = useSurveysPageContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore

  return (
    <div>
      <Breadcrumbs customPath={`/${SurveysPath.root}`} />
      <ContainerHeader
        height={72}
        title={survey.name}
        titleVariant={'heading-lg'}
        titleIconProps={titleIconProps}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        titleIconAction={headerMenuIconAction}
        paddingTop={6}
        paddingLeft={20}
        paddingRight={20}
        actionsProps={{
          actions,
          ...variantActionsProps.headerMedium,
        }}
        ellipsis
      />
      <div className={styles.info}>
        <SurveyActiveToggle className={styles.toggle} item={dataStatus} onToggle={onChangeStatus} />
        <SurveyStatus status={dataStatus.status} />
      </div>
    </div>
  )
})
